import { OnAnimationFrame } from './OnAnimationFrame';
export class AnimationFrameEvent
{
  onAnimationFrame:OnAnimationFrame;
  
  #timeMS:number = 0;
  get timeMS(){ return this.#timeMS; }

  #lastTimeMS:number = 0;
  get lastTimeMS(){ return this.#lastTimeMS; }

  #deltaTimeMS:number = 0;
  get deltaTimeMS(){ return this.#deltaTimeMS; }

  update()
  {
    this.#lastTimeMS = this.#timeMS;
    this.#timeMS = Date.now();
    this.#deltaTimeMS = this.#timeMS - this.#lastTimeMS;
  }
}